// extracted by mini-css-extract-plugin
export default {"container":"xFH59","header":"TXEoD","backBtn":"v6lW6"};